import React, { useCallback, useEffect, useRef, useState } from "react";
import { Dialog, DialogContent, IconButton, Box, ToggleButtonGroup, ToggleButton, Snackbar, Alert, CircularProgress } from "@mui/material";
import { FaEraser, FaFont, FaPencilAlt, FaRedo, FaSave, FaTimes, FaUndo, FaPlus, FaMinus } from "react-icons/fa";
import * as PDFLib from "pdf-lib";
import axios from "axios";
import ButtonWrapper from "../../../obps/src/pages/citizen/AVPForms/components/Button";
export const PdfViewerModal = ({ open, onClose, pdfUrl, onSave, documentIndex, fileStoreId = null }) => {
  // const pdfUrl = "http://localhost:3000/edcr/rest/dcr/viewfile?tenantId=up&fileStoreId=b17928dd-8bb0-4449-9f33-03fc26b980cf";
  const [tool, setTool] = useState("select");
  const [drawing, setDrawing] = useState(false);
  const [textMode, setTextMode] = useState(false);
  const [textInput, setTextInput] = useState("");
  const [textPosition, setTextPosition] = useState({ x: 0, y: 0 });
  const [annotations, setAnnotations] = useState([]);
  const [history, setHistory] = useState([]);
  const [redoHistory, setRedoHistory] = useState([]);
  const [scale, setScale] = useState(1);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [saveStatus, setSaveStatus] = useState({ open: false, message: "", severity: "success" });
  const [savedPdfData, setSavedPdfData] = useState(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const canvasRef = useRef(null);
  const iframeRef = useRef(null);
  const containerRef = useRef(null);
  const startPosRef = useRef({ x: 0, y: 0 });
  const pdfContainerRef = useRef(null);
  const pdfDocRef = useRef(null);
  const pageOffsetsRef = useRef([]);
  const dialogPaperRef = useRef(null);
  const [pdfLib, setPdfLib] = useState(PDFLib);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  pdfUrl = fileStoreId ? `/filestore/v1/files/viewedcr?tenantId=up&fileStoreId=${fileStoreId}` : pdfUrl;

  console.log("I am here asa", pdfUrl, documentIndex);

  // Load PDF-LIB from CDN
  //   useEffect(() => {
  //     if (window.PDFLib) {
  //       setPdfLib(window.PDFLib);
  //       return;
  //     }
  //     // Load PDF-LIB from CDN if not already available
  //     const script = document.createElement("script");
  //     script.src = "https://unpkg.com/pdf-lib@1.17.1/dist/pdf-lib.min.js";
  //     script.onload = () => {
  //       setPdfLib(window.PDFLib);
  //     };
  //     script.onerror = () => {
  //       console.error("Failed to load PDF-LIB from CDN");
  //       setSaveStatus({ open: true, message: "Failed to load PDF library", severity: "error" });
  //     };
  //     document.head.appendChild(script);
  //     return () => {
  //       if (document.head.contains(script)) {
  //         document.head.removeChild(script);
  //       }
  //     };
  //   }, []);
  // Save PDF to filestore when modal opens
  //   useEffect(() => {
  //     if (open && pdfUrl && !savedPdfData) {
  //       console.log("Modal opened, saving PDF to filestore...");
  //     //   savePdfToFilestore(pdfUrl, "document.pdf")
  //     //     .then((result) => {
  //     //       setSavedPdfData(result);
  //     //     })
  //     //     .catch((error) => {
  //     //       console.error("Failed to save PDF to filestore:", error);
  //     //     });
  //     }
  //   }, [open, pdfUrl]);

  const [pdfjs, setPdfjs] = useState(null);

  useEffect(() => {
    if (window.pdfjsLib) {
      setPdfjs(window.pdfjsLib);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";

    script.onload = () => {
      console.log("PDFJS Loaded", window.pdfjsLib);
      window.pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";

      setPdfjs(window.pdfjsLib);
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const showMessage = (message, severity = "success") => {
    setSaveStatus({ open: true, message, severity });
  };

  // const renderPdf = async (currentZoom = zoomLevel) => {
  //   setIsLoading(true);
  //   try {
  //     if (!pdfContainerRef.current || !pdfjs) return;
  //     pdfContainerRef.current.innerHTML = "";

  //     const relativeUrl = pdfUrl.replace(/^https?:\/\/[^/]+/, "");
  //     const response = await axios.get(relativeUrl, { responseType: "arraybuffer" });
  //     const pdfBytes = response.data;

  //     const loadingTask = pdfjs.getDocument({ data: pdfBytes });
  //     const pdf = await loadingTask.promise;

  //     const containerWidth = pdfContainerRef.current.clientWidth || 800;
  //     const dpr = window.devicePixelRatio || 1;

  //     for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
  //       const page = await pdf.getPage(pageNum);
  //       const baseViewport = page.getViewport({ scale: 1 });

  //       const fitScale = (containerWidth - 40) / baseViewport.width;
  //       const finalScale = fitScale * currentZoom;
  //       const viewport = page.getViewport({ scale: finalScale });

  //       const pageWrapper = document.createElement("div");
  //       pageWrapper.style.position = "relative";
  //       pageWrapper.style.marginBottom = "20px";
  //       pageWrapper.style.boxShadow = "0 2px 10px rgba(0,0,0,.2)";
  //       pageWrapper.style.background = "#fff";

  //       const pdfCanvas = document.createElement("canvas");
  //       pdfCanvas.width = viewport.width * dpr;
  //       pdfCanvas.height = viewport.height * dpr;
  //       pdfCanvas.style.width = `${viewport.width}px`;
  //       pdfCanvas.style.height = `${viewport.height}px`;
  //       pdfCanvas.style.display = "block";

  //       const ctx = pdfCanvas.getContext("2d");
  //       ctx.scale(dpr, dpr);
  //       await page.render({ canvasContext: ctx, viewport }).promise;

  //       pageWrapper.appendChild(pdfCanvas);
  //       pdfContainerRef.current.appendChild(pageWrapper);
  //     }

  //     drawAnnotations();
  //   } catch (err) {
  //     console.error(err);
  //     showMessage("Failed to render PDF: " + err.message, "error");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const renderPdf = async (currentZoom = zoomLevel) => {
    setIsLoading(true);
    try {
      if (!pdfContainerRef.current || !pdfjs) return;
      pdfContainerRef.current.innerHTML = "";

      const relativeUrl = fileStoreId ? pdfUrl : pdfUrl.replace(/^https?:\/\/[^/]+/, "");
      const response = await axios.get(relativeUrl, { responseType: "arraybuffer" });
      const pdfBytes = response.data;

      const loadingTask = pdfjs.getDocument({ data: pdfBytes });
      const pdf = await loadingTask.promise;

      const containerWidth = pdfContainerRef.current.clientWidth || 800;
      const dpr = window.devicePixelRatio || 1;

      let runningTop = 0;
      const offsets = [];

      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const baseViewport = page.getViewport({ scale: 1 });

        const fitScale = (containerWidth - 40) / baseViewport.width;
        const finalScale = fitScale * currentZoom;
        const viewport = page.getViewport({ scale: finalScale });

        const pageWrapper = document.createElement("div");
        pageWrapper.style.position = "relative";
        pageWrapper.style.marginBottom = "20px";
        pageWrapper.style.boxShadow = "0 2px 10px rgba(0,0,0,.2)";
        pageWrapper.style.background = "#fff";

        const pdfCanvas = document.createElement("canvas");
        pdfCanvas.width = viewport.width * dpr;
        pdfCanvas.height = viewport.height * dpr;
        pdfCanvas.style.width = `${viewport.width}px`;
        pdfCanvas.style.height = `${viewport.height}px`;
        pdfCanvas.style.display = "block";

        const ctx = pdfCanvas.getContext("2d");
        ctx.scale(dpr, dpr);
        await page.render({ canvasContext: ctx, viewport }).promise;

        pageWrapper.appendChild(pdfCanvas);
        pdfContainerRef.current.appendChild(pageWrapper);

        // record this page's vertical range + render scale in canvas space
        offsets.push({
          pageNum,
          top: runningTop,
          height: viewport.height,
          width: viewport.width,
          renderScale: finalScale, // canvas px per PDF point, at this zoom
        });
        runningTop += viewport.height + 20; // 20px matches marginBottom
      }

      pageOffsetsRef.current = offsets;

      // Resize annotation canvas
      if (canvasRef.current && containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();

        canvasRef.current.width = rect.width;
        canvasRef.current.height = rect.height;
      }

      drawAnnotations();
    } catch (err) {
      console.error(err);
      showMessage("Failed to render PDF: " + err.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleZoomIn = () => {
    const newZoom = Math.min(zoomLevel + 0.25, 4);
    setZoomLevel(newZoom);
    renderPdf(newZoom);
  };

  const handleZoomOut = () => {
    const newZoom = Math.max(zoomLevel - 0.25, 0.25);
    setZoomLevel(newZoom);
    renderPdf(newZoom);
  };

  // Save PDF to filestore and return the fileStoreId
  const savePdfToFilestore = async (url, filename = "document.pdf") => {
    try {
      console.log("Saving PDF to filestore:", url);
      // Fetch the PDF directly (no CORS proxy)
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/pdf, */*",
        },
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch PDF: ${response.status}`);
      }
      const pdfBlob = await response.blob();
      console.log("PDF blob created:", {
        size: pdfBlob.size,
        type: pdfBlob.type,
      });
      // Create FormData for filestore upload
      const formData = new FormData();
      formData.append("file", pdfBlob, filename);
      formData.append("fileType", "pdf");
      formData.append("tenantId", "up");
      formData.append("module", "property-upload");
      formData.append("tag", "tag-property");
      console.log("Uploading to filestore...");
      // Upload to filestore
      const uploadResponse = await axios.post("/filestore/v1/files", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: 30000,
      });
      console.log("Filestore upload response:", uploadResponse.data);
      // Extract fileStoreId from response
      let fileStoreId = null;
      const responseData = uploadResponse.data;
      if (responseData.files && Array.isArray(responseData.files) && responseData.files.length > 0) {
        fileStoreId = responseData.files[0].fileStoreId;
      } else if (responseData.fileStoreId) {
        fileStoreId = responseData.fileStoreId;
      } else if (responseData.response && responseData.response.files) {
        fileStoreId = responseData.response.files[0]?.fileStoreId;
      }
      if (fileStoreId) {
        console.log("PDF saved to filestore with ID:", fileStoreId);
        showMessage("PDF saved to filestore successfully!", "success");
        return { fileStoreId, pdfBlob };
      } else {
        throw new Error("No fileStoreId found in server response");
      }
    } catch (error) {
      console.error("Error saving PDF to filestore:", error);
      showMessage("Failed to save PDF to filestore: " + error.message, "error");
      throw error;
    }
  };

  const handleCloseMessage = () => {
    setSaveStatus({ ...saveStatus, open: false });
  };
  const handleToolChange = (event, newTool) => {
    if (newTool !== null) {
      setTool(newTool);
      setTextMode(newTool === "text");
    }
  };
  // Get accurate coordinates relative to PDF content
  // Get accurate coordinates relative to PDF content
  const getPDFCoordinates = useCallback(
    (clientX, clientY) => {
      if (!canvasRef.current || !containerRef.current) return { x: 0, y: 0 };

      const canvas = canvasRef.current;
      const container = containerRef.current;
      const containerRect = container.getBoundingClientRect();
      const canvasRect = canvas.getBoundingClientRect();

      // Calculate position relative to canvas
      const x = clientX - canvasRect.left;
      const y = clientY - canvasRect.top;

      // Apply scale and offset transformations
      const scaledX = (x - offset.x) / scale;
      const scaledY = (y - offset.y) / scale;

      return { x: scaledX, y: scaledY };
    },
    [scale, offset]
  );
  // const getPDFCoordinates = useCallback((clientX, clientY) => {
  //   if (!canvasRef.current) return { x: 0, y: 0 };
  //   const rect = canvasRef.current.getBoundingClientRect();
  //   const x = clientX - rect.left;
  //   const y = clientY - rect.top;
  //   return { x, y };
  // }, []);

  const handleMouseDown = useCallback(
    (e) => {
      if (!canvasRef.current) return;
      const { x, y } = getPDFCoordinates(e.clientX, e.clientY);
      startPosRef.current = { x, y };
      console.log("Mouse down at coordinates:", { x, y });
      if (tool === "pencil") {
        setDrawing(true);
        const newAnnotation = {
          type: "path",
          points: [{ x, y }],
          color: "#ff0000",
          width: 2,
        };
        console.log("Creating new path annotation:", newAnnotation);
        setAnnotations((prev) => [...prev, newAnnotation]);
      } else if (tool === "text") {
        setTextPosition({ x, y });
      }
    },
    [tool, getPDFCoordinates]
  );
  const handleTextAdd = () => {
    if (!textInput.trim()) return;

    const newTextAnnotation = {
      type: "text",
      text: textInput,
      x: textPosition.x,
      y: textPosition.y,
      color: "#000000",
      fontSize: 16,
    };

    setAnnotations((prev) => [...prev, newTextAnnotation]);

    // Save history for undo
    setHistory((prev) => [...prev, [...annotations]]);
    setRedoHistory([]);

    // Reset
    setTextInput("");
    setTextMode(false);
    setTool("select");
  };
  const handleMouseMove = useCallback(
    (e) => {
      if (!drawing || !canvasRef.current) return;
      const { x, y } = getPDFCoordinates(e.clientX, e.clientY);
      setAnnotations((prev) => {
        const lastAnnotation = prev[prev.length - 1];
        if (lastAnnotation && lastAnnotation.type === "path") {
          const updatedAnnotation = {
            ...lastAnnotation,
            points: [...lastAnnotation.points, { x, y }],
          };
          console.log("Updating path annotation with new point:", { x, y });
          return [...prev.slice(0, -1), updatedAnnotation];
        }
        return prev;
      });
    },
    [drawing, getPDFCoordinates]
  );
  const handleMouseUp = useCallback(() => {
    setDrawing(false);
    // Create a copy of annotations for history
    setHistory((prev) => [...prev, [...annotations]]);
    setRedoHistory([]);
  }, [annotations]);

  const handleUndo = () => {
    if (history.length > 0) {
      const previousState = history[history.length - 1];
      setRedoHistory((prev) => [...prev, [...annotations]]); // Copy current state
      setAnnotations(previousState);
      setHistory((prev) => prev.slice(0, -1));
    }
  };

  const handleRedo = () => {
    if (redoHistory.length > 0) {
      const nextState = redoHistory[redoHistory.length - 1];
      setHistory((prev) => [...prev, [...annotations]]); // Copy current state
      setAnnotations(nextState);
      setRedoHistory((prev) => prev.slice(0, -1));
    }
  };
  const handleClear = () => {
    setHistory((prev) => [...prev, annotations]);
    setRedoHistory([]);
    setAnnotations([]);
  };
  // const handleFitToScreen = () => {
  //   if (iframeRef.current) {
  //     iframeRef.current.src = `${pdfUrl}#zoom=page-width`;
  //   }
  // };

  const handleFitToScreen = async () => {
    try {
      if (!document.fullscreenElement) {
        await dialogPaperRef.current.requestFullscreen();
      } else {
        await document.exitFullscreen();
      }
    } catch (err) {
      console.error("Fullscreen error:", err);
    }
  };

  const exportAnnotatedPdf = async () => {
    console.log("exportAnnotatedPdf STARTED - relativeUrl version");
    try {
      if (!pdfLib) {
        throw new Error("PDF library not loaded");
      }
      if (!annotations || annotations.length === 0) {
        showMessage("No changes to save", "info");
        return null;
      }

      const relativeUrl = fileStoreId ? pdfUrl : pdfUrl.replace(/^https?:\/\/[^/]+/, "");
      console.log("RELATIVE URL", relativeUrl);
      const response = await axios.get(relativeUrl, { responseType: "arraybuffer" });
      const pdfBytes = response.data;

      if (!pdfBytes || pdfBytes.byteLength === 0) {
        throw new Error("Invalid PDF data received");
      }

      const pdfDoc = await pdfLib.PDFDocument.load(pdfBytes);
      const pages = pdfDoc.getPages();
      if (pages.length === 0) {
        throw new Error("PDF has no pages");
      }

      const offsets = pageOffsetsRef.current;

      // Given a y in whole-canvas space, find which page it belongs to
      // and return that page + its local y within the page's canvas region
      const resolvePage = (y) => {
        for (const entry of offsets) {
          if (y >= entry.top && y < entry.top + entry.height) {
            return { ...entry, localY: y - entry.top };
          }
        }
        return null; // fell in a margin/gap, or out of range
      };

      annotations.forEach((annotation) => {
        if (annotation.type === "path" && annotation.points && annotation.points.length > 1) {
          for (let i = 0; i < annotation.points.length - 1; i++) {
            const startPoint = annotation.points[i];
            const endPoint = annotation.points[i + 1];
            if (!startPoint || !endPoint) continue;

            const startInfo = resolvePage(startPoint.y);
            const endInfo = resolvePage(endPoint.y);
            // skip segments that cross a page boundary (start/end on different pages)
            if (!startInfo || !endInfo || startInfo.pageNum !== endInfo.pageNum) continue;

            const pdfPage = pages[startInfo.pageNum - 1];
            console.log("page rotation:", pdfPage.getRotation().angle);
            const { width, height } = pdfPage.getSize();
            const scaleX = width / startInfo.width;
            const scaleY = height / startInfo.height;

            const pdfStartX = startPoint.x * scaleX;
            const pdfStartY = height - startInfo.localY * scaleY;
            const pdfEndX = endPoint.x * scaleX;
            const pdfEndY = height - endInfo.localY * scaleY;

            pdfPage.drawLine({
              start: { x: Math.max(0, Math.min(pdfStartX, width)), y: Math.max(0, Math.min(pdfStartY, height)) },
              end: { x: Math.max(0, Math.min(pdfEndX, width)), y: Math.max(0, Math.min(pdfEndY, height)) },
              color: pdfLib.rgb(
                parseInt(annotation.color.slice(1, 3), 16) / 255,
                parseInt(annotation.color.slice(3, 5), 16) / 255,
                parseInt(annotation.color.slice(5, 7), 16) / 255
              ),
              thickness: annotation.width || 2,
            });
          }
        } else if (annotation.type === "text" && annotation.text) {
          const info = resolvePage(annotation.y);
          if (!info) return;

          const pdfPage = pages[info.pageNum - 1];
          const { width, height } = pdfPage.getSize();
          const scaleX = width / info.width;
          const scaleY = height / info.height;

          const pdfX = annotation.x * scaleX;
          const pdfY = height - info.localY * scaleY;

          pdfPage.drawText(annotation.text, {
            x: Math.max(0, Math.min(pdfX, width)),
            y: Math.max(0, Math.min(pdfY, height)),
            color: pdfLib.rgb(
              parseInt(annotation.color.slice(1, 3), 16) / 255,
              parseInt(annotation.color.slice(3, 5), 16) / 255,
              parseInt(annotation.color.slice(5, 7), 16) / 255
            ),
            size: annotation.fontSize || 16,
          });
        }
      });

      const modifiedPdfBytes = await pdfDoc.save({
        useObjectStreams: false,
        addDefaultPage: false,
        objectsPerTick: 50,
      });

      if (!modifiedPdfBytes || modifiedPdfBytes.byteLength === 0) {
        throw new Error("Failed to generate PDF bytes");
      }

      return new Blob([modifiedPdfBytes], { type: "application/pdf" });
    } catch (error) {
      console.error("Error exporting with PDF-LIB:", error);
      showMessage("Error creating PDF.", "warning");
      throw error;
    }
  };

  const handleSave = async () => {
    try {
      setIsLoading(true);
      console.log("Saving annotations:", annotations);
      // Export the annotated PDF
      const editedFile = await exportAnnotatedPdf();
      // Check if no annotations were made
      if (!editedFile) {
        showMessage("No changes to save", "info");
        return;
      }
      // Validate the file before uploading
      if (!editedFile || editedFile.size === 0) {
        throw new Error("Generated PDF file is empty or invalid");
      }
      console.log("PDF file details:", {
        size: editedFile.size,
        type: editedFile.type,
        name: "document.pdf",
      });
      // Create FormData object
      const formData = new FormData();
      // Ensure the file has proper PDF extension and MIME type
      const fileName = `document_${Date.now()}.pdf`;
      formData.append("file", editedFile, fileName);
      // formData.append("fileType", "pdf");
      formData.append("tenantId", "up");
      formData.append("module", "property-upload");
      formData.append("tag", "tag-property");
      console.log("FormData contents:", {
        fileName: fileName,
        fileSize: editedFile.size,
        fileType: editedFile.type,
      });
      // Make the POST request using axios
      const response = await axios.post("/filestore/v1/files", formData, {});
      console.log("Upload successful:", response.data);
      // Extract fileStoreId from response
      let fileStoreId = null;
      const responseData = response.data;
      // Try different response formats
      if (responseData.files && Array.isArray(responseData.files) && responseData.files.length > 0) {
        fileStoreId = responseData.files[0].fileStoreId;
      } else if (responseData.fileStoreId) {
        fileStoreId = responseData.fileStoreId;
      } else if (responseData.response && responseData.response.files) {
        fileStoreId = responseData.response.files[0]?.fileStoreId;
      }
      if (fileStoreId) {
        // Call the onSave callback with the file store ID and document index
        if (onSave) {
          onSave(fileStoreId, documentIndex);
        }
        showMessage("PDF saved successfully!", "success");
        // Close the modal after a short delay
        setTimeout(() => {
          onClose();
          setIsLoading(false);
        }, 1500);
      } else {
        console.error("Could not extract fileStoreId from response:", responseData);
        throw new Error("No fileStoreId found in server response");
      }
    } catch (error) {
      console.error("Upload error:", error);
      showMessage("Error saving PDF: " + (error.response?.data?.message || error.message), "error");
    }
  };
  // Draw annotations on canvas
  // Draw annotations on canvas
  const drawAnnotations = useCallback(() => {
    if (!canvasRef.current) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    // Clear canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Draw all annotations
    annotations.forEach((annotation) => {
      if (annotation.type === "path") {
        ctx.beginPath();
        ctx.strokeStyle = annotation.color;
        ctx.lineWidth = annotation.width;

        // Apply scale and offset to each point
        annotation.points.forEach((point, i) => {
          const scaledX = point.x * scale + offset.x;
          const scaledY = point.y * scale + offset.y;

          if (i === 0) {
            ctx.moveTo(scaledX, scaledY);
          } else {
            ctx.lineTo(scaledX, scaledY);
          }
        });

        ctx.stroke();
      } else if (annotation.type === "text") {
        ctx.font = `${annotation.fontSize}px Arial`;
        ctx.fillStyle = annotation.color;

        // Apply scale and offset to text position
        const scaledX = annotation.x * scale + offset.x;
        const scaledY = annotation.y * scale + offset.y;

        ctx.fillText(annotation.text, scaledX, scaledY);
      }
    });
  }, [annotations, scale, offset]);

  // const drawAnnotations = useCallback(() => {
  //   if (!canvasRef.current) return;
  //   const ctx = canvasRef.current.getContext("2d");
  //   ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);

  //   annotations.forEach((annotation) => {
  //     if (annotation.type === "path") {
  //       ctx.beginPath();
  //       ctx.strokeStyle = annotation.color;
  //       ctx.lineWidth = annotation.width;
  //       annotation.points.forEach((point, i) => {
  //         if (i === 0) ctx.moveTo(point.x, point.y);
  //         else ctx.lineTo(point.x, point.y);
  //       });
  //       ctx.stroke();
  //     } else if (annotation.type === "text") {
  //       ctx.font = `${annotation.fontSize}px Arial`;
  //       ctx.fillStyle = annotation.color;
  //       ctx.fillText(annotation.text, annotation.x, annotation.y);
  //     }
  //   });
  // }, [annotations]);
  // Update canvas size and handle PDF loading
  // Update canvas size and handle PDF loading
  useEffect(() => {
    if (containerRef.current && canvasRef.current) {
      const container = containerRef.current;
      const canvas = canvasRef.current;

      const resizeCanvas = () => {
        const rect = container.getBoundingClientRect();
        canvas.width = rect.width;
        canvas.height = rect.height;
        drawAnnotations();
      };

      resizeCanvas();

      const resizeObserver = new ResizeObserver(resizeCanvas);
      resizeObserver.observe(container);

      return () => resizeObserver.disconnect();
    }
  }, [drawAnnotations]);

  useEffect(() => {
    const handleFullscreenChange = () => {
      const fullscreen = !!document.fullscreenElement;

      setIsFullscreen(fullscreen);

      setTimeout(() => {
        renderPdf(zoomLevel);
      }, 200);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, [zoomLevel]);

  // Handle iframe load to detect PDF dimensions
  const handleIframeLoad = useCallback(() => {
    if (iframeRef.current && iframeRef.current.contentDocument) {
      const iframeDoc = iframeRef.current.contentDocument;
      const pdfContainer = iframeDoc.querySelector(".pdfViewer") || iframeDoc.body;
      // Try to detect PDF.js viewer structure
      if (pdfContainer) {
        const pdfWidth = pdfContainer.scrollWidth;
        const pdfHeight = pdfContainer.scrollHeight;
        // Calculate scale to fit PDF in container
        const container = containerRef.current;
        if (container) {
          const scaleX = container.clientWidth / pdfWidth;
          const scaleY = container.clientHeight / pdfHeight;
          const newScale = Math.min(scaleX, scaleY, 1);
          setScale(newScale);
          setOffset({
            x: (container.clientWidth - pdfWidth * newScale) / 2,
            y: (container.clientHeight - pdfHeight * newScale) / 2,
          });
        }
      }
    }
  }, []);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        ref: dialogPaperRef,
      }}
      TransitionProps={{
        onEntered: () => {
          console.log("Dialog entered");

          if (pdfjs && pdfUrl && pdfContainerRef.current) {
            renderPdf();
          }
        },
        // onEntered: () => {
        //   if (pdfjs && pdfUrl && pdfContainerRef.current) {
        //     loadAndRenderPdf(); // was renderPdf()
        //   }
        // },
      }}
      sx={{
        "& .MuiDialog-paper": {
          width: "95vw",
          height: "95vh",
          maxWidth: "95vw",
          margin: 0,
          borderRadius: "8px",
        },
      }}
    >
      <DialogContent sx={{ p: 1, height: "100%", display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px" }}>
          <ToggleButtonGroup value={tool} exclusive onChange={handleToolChange} aria-label="tool selection" size="small">
            <ToggleButton value="select" aria-label="select">
              <FaTimes />
            </ToggleButton>
            <ToggleButton value="pencil" aria-label="pencil">
              <FaPencilAlt />
            </ToggleButton>
            <ToggleButton value="text" aria-label="text">
              <FaFont />
            </ToggleButton>
            <ToggleButton value="eraser" aria-label="eraser" onClick={handleClear}>
              <FaEraser />
            </ToggleButton>
            {/* <ToggleButton value="minus" aria-label="minus" onClick={handleZoomOut} disabled={isLoading}>
              <FaMinus />
            </ToggleButton>
            <ToggleButton value="plus" aria-label="plus" onClick={handleZoomIn} disabled={isLoading}>
              <FaPlus />
            </ToggleButton> */}
          </ToggleButtonGroup>
          <Box>
            <IconButton onClick={handleUndo} disabled={history.length === 0}>
              <FaUndo />
            </IconButton>
            <IconButton onClick={handleRedo} disabled={redoHistory.length === 0}>
              <FaRedo />
            </IconButton>
            <IconButton onClick={handleSave} color="primary">
              <FaSave />
            </IconButton>
            <IconButton onClick={handleFitToScreen} title="Fit to screen">
              🖥️
            </IconButton>
            <IconButton onClick={onClose}>
              <FaTimes />
            </IconButton>
          </Box>
        </div>
        <div
          className="iframe-container"
          ref={containerRef}
          style={{ position: "relative", flex: 1 }}
          // style={{
          //   position: "relative",
          //   flex: 1,
          //   minHeight: 0,
          //   overflow: "hidden",
          // }}
        >
          {/* <iframe
            className="fastPas-iframe"
            ref={iframeRef}
            src={`${pdfUrl}#zoom=page-width`}
            title="PDF Document"
            onLoad={handleIframeLoad}
            style={{
              width: "100%",
              height: "100%",
              border: "none",
            }}
          ></iframe> */}
          <div
            ref={pdfContainerRef}
            style={{
              flex: 1,
              overflow: "auto",
              background: "#808080",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "20px",
            }}

            // style={{
            //   position: "absolute",
            //   top: 0,
            //   left: 0,
            //   right: 0,
            //   bottom: 0,
            //   overflow: "auto",
            //   background: "#808080",
            //   display: "flex",
            //   flexDirection: "column",
            //   alignItems: "center",
            //   padding: "20px",
            // }}
          />
          <canvas
            ref={canvasRef}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              pointerEvents: tool === "select" ? "none" : "auto",
              cursor: tool === "pencil" ? "crosshair" : "default",
            }}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
          />
          {isLoading && (
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(255,255,255,0.6)",
                zIndex: 10,
              }}
            >
              <CircularProgress />
            </Box>
          )}
        </div>
        {textMode && (
          <Box sx={{ p: 2, borderTop: "1px solid #ccc" }}>
            <input
              type="text"
              value={textInput}
              onChange={(e) => setTextInput(e.target.value)}
              placeholder="Enter text to add"
              style={{ marginRight: "8px", padding: "4px" }}
            />
            <ButtonWrapper variant="contained" size="small" onClick={handleTextAdd} disabled={!textInput.trim()}>
              Add Text
            </ButtonWrapper>
            <ButtonWrapper
              variant="outlined"
              size="small"
              onClick={() => {
                setTextMode(false);
                setTool("select");
              }}
              style={{ marginLeft: "8px" }}
            >
              Cancel
            </ButtonWrapper>
          </Box>
        )}
        <Snackbar
          open={saveStatus.open}
          autoHideDuration={6000}
          onClose={handleCloseMessage}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert onClose={handleCloseMessage} severity={saveStatus.severity} sx={{ width: "100%" }}>
            {saveStatus.message}
          </Alert>
        </Snackbar>
      </DialogContent>
    </Dialog>
  );
};
